<script lang="ts">
  import Loader from '$shared/atoms/Loader/Loader.svelte';
  import OverviewTableRow from './OverviewTableRow.svelte';
  import type { AlertAction } from '$shared/models/AlertAction';

  interface Props {
    loading?: boolean;
    columns?: ColumnType[];
    rows?: any[];
    alerts?: ObjectType<AlertAction[]>;
    name?: string;
    getRowOptions?: any;
    customRowComponent?: ConstructorOfATypedSvelteComponent | undefined;
    onclick?: (payload: any) => void;
    onclickoption?: (payload: { option: CommonList; row: any }) => void;
    onclickAlert?: (payload: any) => void;
    onevent?: (payload: any) => void;
  }

  let {
    loading = false,
    columns = [],
    rows = [],
    alerts = {},
    name = '',
    getRowOptions = () => {},
    customRowComponent = undefined,
    onclick,
    onclickoption,
    onclickAlert,
    onevent
  }: Props = $props();

  let colLength = $derived(columns.length + 1);
</script>

<div class="comp-overview-table">
  <table data-cy={`${name}-table`} cellspacing="0">
    <thead data-cy={`${name}-thead`}>
      <tr>
        {#each columns as col}
          <th data-cy={`${col.label}-th`} width={col.width || ''}>{col.label}</th>
        {/each}
        <th class="option-head" width="30px">{''}</th>
      </tr>
    </thead>
    <tbody data-cy={`${name}-tbody`}>
      {#if loading}
        <tr>
          <td colspan={colLength}>
            <div class="loader-cell">
              <Loader />
            </div>
          </td>
        </tr>
      {:else if customRowComponent}
        {@const SvelteComponent = customRowComponent}
        <SvelteComponent {columns} />
      {:else if Array.isArray(rows)}
        {#each rows.filter(Boolean) as row}
          <OverviewTableRow
            {row}
            {columns}
            {alerts}
            {getRowOptions}
            {onclick}
            {onclickoption}
            {onclickAlert}
            {onevent}
          />
        {/each}
      {:else}
        <tr class="empty">
          <td colspan={colLength}>No Data Found</td>
        </tr>
      {/if}
    </tbody>
  </table>
</div>

<style src="./OverviewTable.css">
</style>
